import { api } from "./api";

// Chunks stay below the ingress request limit. The server controls chunk size.
export async function uploadResume(file, jobId, previous, onSession, onProgress) {
  let session = previous;
  if (!session) {
    onProgress({ percent: 0, label: "Preparing private upload…" });
    const { data } = await api.post("/resume-uploads", { job_id: jobId, filename: file.name, size: file.size });
    session = { ...data, next: 0, ready: false };
    onSession(session);
  }
  if (session.ready) return session.upload_id;
  for (let index = session.next; index < session.chunk_count; index++) {
    const start = index * session.chunk_size;
    const chunk = file.slice(start, Math.min(start + session.chunk_size, file.size));
    onProgress({ percent: Math.round(start / file.size * 90), label: `Uploading resume: part ${index + 1} of ${session.chunk_count}…` });
    await api.put(`/resume-uploads/${session.upload_id}/chunks/${index}`, chunk, {
      headers: { "Content-Type": "application/octet-stream" },
      onUploadProgress: (event) => onProgress({ percent: Math.min(90, Math.round((start + event.loaded) / file.size * 90)), label: `Uploading resume: part ${index + 1} of ${session.chunk_count}…` }),
    });
    session = { ...session, next: index + 1 };
    onSession(session);
  }
  onProgress({ percent: 92, label: "Validating and saving your resume to private storage…" });
  await api.post(`/resume-uploads/${session.upload_id}/complete`);
  onSession({ ...session, ready: true });
  onProgress({ percent: 96, label: "Resume stored. Saving your application…" });
  return session.upload_id;
}
